import { combineReducers } from 'redux';
import brands from './brands/reducer';
import categories from './categories/reducer';
import { SET_ECOM_TITLE, SET_PO_TITLE, SET_REPORT_TITLE, SET_TITLE } from './constants';
import products from './products/reducer';
import purchaseOrders from './purchaseOrders/reducer';
import { productInventoryReducer, productShrinkageReducer, productValuationReducer } from './reports/reducer';

const titleReducer = (state = '', { type, payload }) => {
  switch (type) {
    case SET_TITLE:
      return payload;
    case SET_REPORT_TITLE:
    case SET_ECOM_TITLE:
    case SET_PO_TITLE:
      return '';
    default:
      return state;
  }
};

const reportTitleReducer = (state = '', { type, payload }) => {
  switch (type) {
    case SET_REPORT_TITLE:
      return payload;
    case SET_TITLE:
    case SET_ECOM_TITLE:
    case SET_PO_TITLE:
      return '';
    default:
      return state;
  }
};

const poTitleReducer = (state = '', { type, payload }) => {
  switch (type) {
    case SET_PO_TITLE:
      return payload;
    case SET_TITLE:
    case SET_ECOM_TITLE:
    case SET_REPORT_TITLE:
      return '';
    default:
      return state;
  }
};

const ecomInitialTitle = 'Ecommerce';

const ecomTitleReducer = (state = ecomInitialTitle, { type, payload }) => {
  switch (type) {
    case SET_ECOM_TITLE:
      return payload;
    case SET_TITLE:
    case SET_PO_TITLE:
    case SET_REPORT_TITLE:
      return ecomInitialTitle;
    default:
      return state;
  }
};

const reducer = combineReducers({
  title: titleReducer,
  reportTitle: reportTitleReducer,
  poTitle: poTitleReducer,
  ecomTitle: ecomTitleReducer,
  categories,
  brands,
  products,
  productInventory: productInventoryReducer,
  productShrinkage: productShrinkageReducer,
  productValuation: productValuationReducer,
  purchaseOrders,
});

export default reducer;
